export enum CategoryType {
  CategoryDivider = 'category-divider',
}
